import { Text } from "@gravity-ui/uikit";
import { AnimatePresence, type AnimationProps, motion } from "framer-motion";

import css from "../../SliderCard.module.scss";
import { CardIcon, CoinIcon, LockIcon } from "./components";

const titleAnimation: AnimationProps = {
  initial: { scale: 0.6, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  exit: {
    scale: 0.6,
    opacity: 0,
    transition: { delay: 0, duration: 0.1 },
  },
  transition: { delay: 0.2 },
};

const iconAnimation: AnimationProps = {
  initial: { scale: 0.6, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  exit: {
    scale: 0.6,
    opacity: 0,
    transition: { delay: 0, duration: 0.1 },
  },
};

export const SlideBalance = ({ activeIndex }: { activeIndex: number }) => {
  return (
    <>
      <AnimatePresence initial={true} mode="wait">
        <motion.div {...titleAnimation} key={"title.slide." + activeIndex}>
          <Text variant="subheader-2">Подписки</Text>
        </motion.div>
      </AnimatePresence>

      <div className={css.slideBalanceContainer}>
        <motion.div
          style={{ position: "absolute", x: -60, y: 80 }}
          {...iconAnimation}
          transition={{ delay: 0.2, type: "spring" }}
          key={"coin." + activeIndex}
        >
          <CoinIcon />
        </motion.div>
        <motion.div
          style={{ position: "absolute", x: 60, y: 130 }}
          {...iconAnimation}
          transition={{ delay: 0.4, type: "spring" }}
          key={"card." + activeIndex}
        >
          <CardIcon />
        </motion.div>
        <motion.div
          style={{ position: "absolute", x: 20, y: 40 }}
          {...iconAnimation}
          transition={{ delay: 0.6, type: "spring" }}
          key={"lock." + activeIndex}
        >
          <LockIcon />
        </motion.div>
      </div>
    </>
  );
};
